<mat-nav-list [ngClass]="{'menu-hide':!isExpand && forRestrictView}">
    <div class="app-title cursor" (click)="onChangeSideNav()">
        <img *ngIf="isExpand" src="assets/img/hamburger_menu.svg" />
        <img *ngIf="!isExpand" src="assets/img/hamburger_menu_back.svg" />
    </div>
    <div>
        <mat-list *ngFor="let item of menuItems">
            <mat-list-item id="{{item.name}}" [routerLinkActive]="['active']" routerLink="{{item.link}}">
                <mat-icon [svgIcon]="item.icon" *ngIf="item.source == 'custom'"></mat-icon>
                <mat-icon *ngIf="item.source == 'mat'">{{item.icon}}</mat-icon>
                <span class="list-item-text" *ngIf="isExpand">{{item.name}}</span>
            </mat-list-item>
        </mat-list>
    </div>
</mat-nav-list>